export default __webpack_public_path__ + "static/media/whiteXICcon.1e352aee.svg";